/* eslint-disable react-hooks/exhaustive-deps */
import { Box, LoaderNew, ModBox, TextNew } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import ActionsMenu from '../../../../components/ActionMenu/ActionsMenu'
import { DualActionButtonComp } from '../../../../components/DualActionButtonComp'
import { useLazyApiData, useStores } from '../../../../data/store'

import { bulkEntityStringConstants } from '../../../../utils/constants'
import { SelectParentEntityList } from '../../Onboarding/CreateEntity/SelectParentEntityList'
import { flexMapperWithIndex, headerData } from './Fixtures'
import { styles } from './styles'

interface UploadedFileHistoryInterface {
  type: 'bulkUpload' | 'tid' | 'bulkConfig' | 'bulkCard'
  onViewPress: (data: any) => void
  onUploadNewFile?: () => void
  onDone?: () => void
}

const UploadedFileHistory = React.memo(
  ({ type, onViewPress, onUploadNewFile, onDone }: UploadedFileHistoryInterface) => {
    const { getUploadedFileHistory, getBulkUploadedFilesList, downloadBulkOnboardingFile } = useStores((root) => ({
      getUploadedFileHistory: root.getUploadedFileHistory,
      getBulkUploadedFilesList: root.bulkEntity.getBulkUploadedFilesList,
      downloadBulkOnboardingFile: root.bulkEntity.downloadBulkOnboardingFile,
    }))

    const [fileHistoryLoader, toggleFileHistoryLoader] = useState(true)
    const [getHistory, { state }] = useLazyApiData(getUploadedFileHistory)
    const [list, setList] = useState([])

    useEffect(() => {
      getHistory(type, 10)
    }, [])

    useEffect(() => {
      if (state === 'pending') {
        toggleFileHistoryLoader(true)
      } else if (state === 'fulfilled') {
        const data = getBulkUploadedFilesList()
        setList(data)
        toggleFileHistoryLoader(false)
      } else if (state === 'rejected') {
        toggleFileHistoryLoader(false)
        const data = getBulkUploadedFilesList()
        setList(data)
      }
    }, [getBulkUploadedFilesList, state])

    const fetchDataOnChange = () => {
      console.log('fetchDataOnChange:')
      getHistory(type, 10)
    }

    const onSubmitPress = () => {
      console.log('onSubmitPress:')
      onDone && onDone()
    }
    const onUploadNewFilePress = () => {
      console.log('onUploadNewFilePress:')
      onUploadNewFile && onUploadNewFile()
    }

    const onDownloadPress = (data: any) => {
      downloadBulkOnboardingFile(data?.id, type)
    }
    return (
      <Box {...styles.boxContainer}>
        <TextNew title={bulkEntityStringConstants[type].fileHistoryUploadDetails} {...styles.headerTitle} />
        <ModBox show={!fileHistoryLoader}>
          <ActionsMenu
            fetchDataOnChange={fetchDataOnChange}
            showSearch={false}
            enableFilter={false}
            showCalendar
            defaultPage={1}
          />
        </ModBox>
        <ModBox show={!fileHistoryLoader} minHeight={472} marginTop={16} flex={1}>
          <SelectParentEntityList
            title={''}
            hide={false}
            data={list}
            headerTitles={headerData}
            columnFlexMapper={flexMapperWithIndex}
            onViewPress={onViewPress}
            onDownloadPress={onDownloadPress}
          />
        </ModBox>
        <ModBox show={fileHistoryLoader} flex={1} justifyContent={'center'}>
          <LoaderNew color={'BLUE'} type={'large'} />
        </ModBox>
        <ModBox show={!fileHistoryLoader}>
          <DualActionButtonComp
            isOutlineButtonVisible={true}
            isColoredButtonVisible={true}
            isValid={true}
            outlineButtonTitle={bulkEntityStringConstants[type].uploadNewFile}
            coloredButtonText={'Done'}
            onColoredButtonPress={onSubmitPress}
            onOutlineButtonPress={onUploadNewFilePress}
          />
        </ModBox>
      </Box>
    )
  },
)

export { UploadedFileHistory }
